export default "__VITE_ASSET__CSowd2wB__"